import { z } from 'zod';

export const loginSchema = z.object({
  email: z
    .string()
    .toLowerCase()
    .min(1, { message: 'Email address is required.' })
    .email('Please enter a valid email.'),
  password: z.string().min(1, { message: 'Password is required.' }),
});
